export default "__VITE_ASSET__af982b32__"